// src/services/userService.js
import apiClient from './api'; // Axios instance

export default {
  // Mevcut kullanıcının profilini güncelleme
  updateProfile(profileData) {
    // profileData: { username: '...', profile_title: '...' } gibi güncellenecek veriler
    return apiClient.put('/users/profile', profileData); // Backend API endpoint'i: PUT /api/users/profile
  },

  // === Diğer Kullanıcı İşlemleri (Gelecekte eklenebilir) ===

  // Kullanıcının favori ilanlarını alma
  getFavorites() {
    return apiClient.get('/users/favorites'); // GET /api/users/favorites
  },

  // Bir ilanı favorilere ekleme
  addFavorite(announcementId) {
    return apiClient.post(`/users/favorites/${announcementId}`); // POST /api/users/favorites/:announcementId
  },

  // Bir ilanı favorilerden çıkarma
  removeFavorite(announcementId) {
    return apiClient.delete(`/users/favorites/${announcementId}`); // DELETE /api/users/favorites/:announcementId
  },

  // TODO: Alarmlar için servis fonksiyonları (getAlerts, addAlert, removeAlert)
  // TODO: Mesajlaşma için servis fonksiyonları (getConversations, getMessages, sendMessage)
  // TODO: Bildirimler için servis fonksiyonları (getNotifications, markAsRead)

};